import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import services from '../../services';
import { useDispatch } from 'react-redux';
import { toggleDate, toggleTable } from '../../Redux/slice';
import { getAllDateTableTask } from '../../Redux/GetSlice';
import { getLocalStorageItem, setLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';

const ArchivedHeader = ({ isArchivedView, selectedBoard, availableBoards, onBoardChange }) => {
    const [activeButton, setActiveButton] = useState('board');
    const [boardName, setBoardName] = useState([]);
    const [navBoard, setNavBoard] = useState(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        getAllBoard();
    }, []);

    const getAllBoard = async () => {
        try {
            const { data } = await services.board.GETALLBOARD();
            const mapData = data?.map(({ boardName, id }) => ({ label: boardName, value: id }));
            setBoardName(mapData);
            const savedBoardId = getLocalStorageItem('boardId')
            if (savedBoardId && mapData.length > 0) {
                const board = mapData.find((b) => b.value === savedBoardId);
                setNavBoard(board || mapData[0]);
            } else if (mapData.length > 0) {
                setNavBoard(mapData[0]);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const handleClick = (button) => {
        setActiveButton(button);
        const boardId = navBoard?.value;

        if (button === 'board') {
            dispatch(toggleTable(false));
            dispatch(toggleDate(false));
            navigate('/app');
        } else if (button === 'date') {
            if (boardId) {
                dispatch(getAllDateTableTask({ data: { boardId } }));
            }
            dispatch(toggleDate(true));
            dispatch(toggleTable(false));
            navigate('/app');
        } else if (button === 'table') {
            dispatch(toggleTable(true));
            dispatch(toggleDate(false));
            navigate('/app');
        }
    };

    const handleSelectedBoard = (e) => {
        setNavBoard(e);
        setLocalStorageItem('boardId', e?.value)
        window.location.reload();
    };

    const getButtonClass = (button) =>
        `p-[7px] ${activeButton === button ? 'bg-[#20212414]' : 'bg-white'
        } mr-[5px] items-center flex cursor-pointer text-black gap-[4px] rounded-[5px]`;

    return (
        <div className="header-app flex items-center justify-between px-4 py-3 border-b bg-white">
            <button
                onClick={() => { isArchivedView == false ? navigate("/kanban") : navigate(-1) }}
                className="px-4 py-2 font-semibold bg-white border rounded-md text-sm"
                style={{ color: '#1a7d3e', borderColor: '#1a7d3e' }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f0faf4'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fff'}
            >
                Back
            </button>
            {availableBoards !== undefined && (
                <Select
                    value={{ value: selectedBoard, label: selectedBoard }}
                    onChange={(opt) => onBoardChange({ target: { value: opt.value } })}
                    options={availableBoards.map((board) => ({ value: board.boardName, label: board.boardName }))}
                    isSearchable={false}
                    styles={{
                        control: (base, state) => ({
                            ...base,
                            minWidth: '180px',
                            fontSize: '14px',
                            borderColor: state.isFocused ? '#1a7d3e' : '#d1d5db',
                            boxShadow: state.isFocused ? '0 0 0 2px rgba(26,125,62,0.18)' : 'none',
                            '&:hover': { borderColor: '#1a7d3e' },
                            cursor: 'pointer',
                        }),
                        option: (base, state) => ({
                            ...base,
                            backgroundColor: state.isSelected
                                ? '#1a7d3e'
                                : state.isFocused
                                ? '#e6f4ed'
                                : '#fff',
                            color: state.isSelected ? '#fff' : '#222',
                            fontWeight: state.isSelected ? 600 : 400,
                            cursor: 'pointer',
                        }),
                        singleValue: (base) => ({ ...base, color: '#222' }),
                        indicatorSeparator: () => ({ display: 'none' }),
                        dropdownIndicator: (base) => ({ ...base, color: '#1a7d3e', padding: '0 8px' }),
                    }}
                />
            )}
        </div>
    );
};

export default ArchivedHeader; 